module.exports = __webpack_public_path__ + "static/media/mcgonagall.e1fe26ac.jpg";